import IconInput from "components/ui/IconInput";
import { Field, FieldArray, Form, Formik } from "formik";
import { Button } from "primereact/button";

const RoleForm = ({ initialValues, onSubmit }) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        const errors = {};
        if (!values.name) {
          errors.name = "Role name is required";
        }

        if (!values.privileges.length) {
          errors.name = "At least one privilege is required";
        }
        return errors;
      }}
    >
      {({ values, handleChange, setFieldValue }) => (
        <Form className="flex flex-column gap-3">
          {/* Role Name */}
          <IconInput
            id="name"
            name="name"
            label="Role Name"
            required
            value={values.name}
            onChange={handleChange}
          />

          {/* Privileges */}
          <FieldArray name="privileges">
            {({ push, remove }) => (
              <div className="flex flex-column gap-2">
                <label htmlFor="privileges" className="font-semibold">
                  Privileges
                </label>
                {values.privileges.map((privilege, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    <Field
                      name={`privileges.${index}`}
                      placeholder="Enter privilege"
                      className="p-2 border rounded w-full"
                    />
                    <Button
                      label="Remove"
                      severity="danger"
                      icon="pi pi-times"
                      type="button"
                      onClick={() => remove(index)}
                    />
                  </div>
                ))}
                <Button
                  label="Add Privilege"
                  severity="success"
                  type="button"
                  icon="pi pi-plus"
                  onClick={() => push("")}
                />
              </div>
            )}
          </FieldArray>

          {/* Submit Button  */}
          <Button type="submit" label="Submit" className="mt-3" />
        </Form>
      )}
    </Formik>
  );
};

export default RoleForm;
